import { render, staticRenderFns } from "./limitPrice.vue?vue&type=template&id=68acdd9e&scoped=true&"
import script from "./limitPrice.vue?vue&type=script&lang=js&"
export * from "./limitPrice.vue?vue&type=script&lang=js&"
import style0 from "./limitPrice.vue?vue&type=style&index=0&id=68acdd9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68acdd9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68acdd9e')) {
      api.createRecord('68acdd9e', component.options)
    } else {
      api.reload('68acdd9e', component.options)
    }
    module.hot.accept("./limitPrice.vue?vue&type=template&id=68acdd9e&scoped=true&", function () {
      api.rerender('68acdd9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/center/limitPrice/limitPrice.vue"
export default component.exports